'use client';

import React from 'react';
import Link from 'next/link';
import { Shield, Home, ArrowLeft } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ background: 'linear-gradient(135deg, #0F2041 0%, #0a1628 100%)' }}
    >
      <div className="text-center max-w-lg">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-10">
          <AppLogo size={36} />
          <span className="font-bold text-xl text-white tracking-tight">Ertzyx</span>
        </div>

        {/* 404 visual */}
        <div className="relative mb-8">
          <h1
            className="text-[120px] font-bold leading-none select-none"
            style={{ color: 'rgba(255,255,255,0.06)' }}
          >
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center">
              <Shield size={36} className="text-blue-300" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-2xl font-bold text-white mb-3">This record doesn&apos;t exist yet</h2>
        <p className="text-blue-300 text-base leading-relaxed mb-10 max-w-sm mx-auto">
          The page you&apos;re looking for hasn&apos;t been added to the ledger. Every great story
          starts somewhere — yours can start here.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/">
            <button className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl font-bold text-sm bg-white text-trust-blue hover:bg-blue-50 transition-colors w-full sm:w-auto">
              <Home size={16} />
              Go Back Home
            </button>
          </Link>
          <button
            onClick={() => window.history?.back()}
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl font-bold text-sm border border-white/25 text-white hover:bg-white/10 transition-colors w-full sm:w-auto"
          >
            <ArrowLeft size={16} />
            Go Back
          </button>
        </div>

        {/* Quick links */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 text-sm text-blue-400">
          <Link href="/verify" className="hover:text-white transition-colors">
            Verify a Record
          </Link>
          <span className="text-white/20">·</span>
          <Link href="/pricing" className="hover:text-white transition-colors">
            Pricing
          </Link>
          <span className="text-white/20">·</span>
          <Link href="/contact" className="hover:text-white transition-colors">
            Contact
          </Link>
          <span className="text-white/20">·</span>
          <Link href="/about" className="hover:text-white transition-colors">
            About
          </Link>
        </div>
      </div>
    </div>
  );
}
